export { default } from "./numeric-details-field";
